import { FC, ReactNode } from 'react';
import { useEnvironment } from '../hooks/useEnvironment';

interface RenderInDevelopmentOnlyProps {
  children: ReactNode;

  /**
   * Optional content to show in production builds.
   */
  fallback?: ReactNode;
}

/**
 * Component that renders its children only in development environments (dev and test)
 *
 * A more simplified version of the Feature component, intended for lowering the usage of feature flags
 */
export const RenderInDevelopmentOnly: FC<RenderInDevelopmentOnlyProps> = ({ children, fallback = null }) => {
  const { isProd } = useEnvironment();

  // If not in production, show the children with a red striped background
  return !isProd ? <div className="bg-[repeating-linear-gradient(135deg,rgba(239,68,68,0.10)_0_16px,rgba(239,68,68,0.05)_16px_32px)]">{children}</div> : <>{fallback}</>;
};
